import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/base/ui/breadcrumb'
import {WuButton} from '@/components/button'
import {Fragment} from 'react'
import {IWuAppHeaderBreadcrumbItem} from '../../types/WuAppHeaderBreadcrumbItem'
import {WuTruncatedLabel} from '../WuTruncatedLabel'

// Props interface
export interface IWuAppHeaderBreadcrumbProps {
  breadcrumbs: IWuAppHeaderBreadcrumbItem[]
  dir?: 'ltr' | 'rtl'
}

// Main Breadcrumb Component
export const WuAppHeaderBreadcrumb: React.FC<IWuAppHeaderBreadcrumbProps> = ({
  breadcrumbs,
  dir,
}) => {
  const getItemWidthClass = (isLast: boolean): string =>
    isLast ? 'max-w-[250px]' : 'max-w-[150px]'

  return (
    <Breadcrumb className="hidden w-full sm:block" dir={dir}>
      <BreadcrumbList className="flex-nowrap wu-breadcrumb-nav">
        {breadcrumbs.map((item, index) => {
          const isLastItem = index === breadcrumbs.length - 1
          const widthClass = getItemWidthClass(isLastItem)

          return (
            <Fragment key={index}>
              <BreadcrumbItem className={`truncate ${widthClass}`}>
                {isLastItem ? (
                  <BreadcrumbPage className="wu-breadcrumb-page">
                    <WuTruncatedLabel
                      label={item.label}
                      className="text-sm font-normal"
                    />
                  </BreadcrumbPage>
                ) : 'onClick' in item ? (
                  <WuButton
                    variant="link"
                    className="wu-breadcrumb-button"
                    onClick={item.onClick}
                  >
                    <WuTruncatedLabel
                      label={item.label}
                      className="text-sm font-normal"
                    />
                  </WuButton>
                ) : (
                  <BreadcrumbLink
                    href={item.link}
                    className="wu-breadcrumb-link"
                  >
                    <WuTruncatedLabel
                      label={item.label}
                      className="text-sm font-normal"
                    />
                  </BreadcrumbLink>
                )}
              </BreadcrumbItem>
              {!isLastItem && (
                <BreadcrumbSeparator
                  dir={dir}
                  className="pt-1 wu-breadcrumb-separator"
                />
              )}
            </Fragment>
          )
        })}
      </BreadcrumbList>
    </Breadcrumb>
  )
}
